import React, {Component} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ArchiveModal extends Component{
    onSubmit(){
        this.props.toggler();
        if(this.props.activateCaso){
            this.props.actionArchive();
        }else{
            this.props.actionActivate();
        }
    }
    render(){
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>{this.props.activateCaso ? <span>Archivar caso</span> : <span>Activar caso</span>}</ModalHeader>
                <ModalBody>
                    {this.props.activateCaso ?
                        <span>El caso dejará de mostrase en el listado de casos activos, puede visualizarlo de nuevo marcando la opción “Mostrar casos archivados”.</span>
                        :
                        <span>El caso volverá a mostrarse en el listado de casos activos.</span>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={this.onSubmit.bind(this)}>Guardar</Button>{' '}
                </ModalFooter>
            </Modal>

        )
    }
}
export default ArchiveModal


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/ArchiveModal.jsx